// Route-level identity for the schedule currently open. Module-scoped so it
// survives re-renders without a context: only the route component knows
// these, and both the hook and the API adapter need them.
let briefIds = { bookingId: undefined, briefUuid: undefined };
// A staff read through the staff's own customer token: everything renders,
// nothing writes.
let readOnlyMode = false;
// The server can say the same thing, once the form is submitted or closed.
let payloadReadOnly = false;
// Which side of the couple a staff read is made as. The server needs a
// participant to read the saved answers for: without one it answers with
// unsaved preview rows, which is not what ops opened the link to see.
let asRole = null;

export const setSession = ({ bookingId, briefUuid, readOnly, asRole: role }) => {
  briefIds = { bookingId, briefUuid };
  readOnlyMode = !!readOnly;
  asRole = role || null;
};

/** Set from the bootstrap response, which owns the submitted and locked cases. */
export const setPayloadReadOnly = (value) => {
  payloadReadOnly = !!value;
};

// Accessors rather than exported bindings: both are reassigned, and consumers
// must see the current value, not the one captured at import.
export const getBriefIds = () => briefIds;
export const getAsRole = () => asRole;
// Either source is enough to block every write.
export const isReadOnly = () => readOnlyMode || payloadReadOnly;
